import { DatePipe } from '@angular/common';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Component, HostListener, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSidenav } from '@angular/material/sidenav';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { forkJoin } from 'rxjs';
import { ILocationDetails } from 'src/app/models/ILocationDetails';
import { IMessagesTasksInbox } from 'src/app/models/IMessagesTasksInbox';
import { IPersonalInfo } from 'src/app/models/IPersonalInfo';
import { IMasterMessageType, TaskGroupUsers, UserGroupMapping } from 'src/app/models/TasksAndGroups';
import { PatientSearchComponent } from 'src/app/patient-search/patient-search.component';
import { SchedularServiceService } from 'src/app/Services/Schedular/schedular-service.service';
import { TasksAndGroupsService } from 'src/app/Services/TaskAndGroup/tasks-and-groups.service';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';
import { SharedService } from 'src/app/Sharedservice/SharedService';
declare let $: any;
@Component({
  selector: 'app-taskmessagesnewtask',
  templateUrl: './taskmessagesnewtask.component.html',
  styleUrls: ['./taskmessagesnewtask.component.css']
})
export class TaskmessagesnewtaskComponent implements OnInit {
  NewTaskMessagesForm: FormGroup;
  IsShowUserGroup: boolean = true;
  fromUserName: string = '';
  fromCreated: any;
  minDate = new Date();
  loginUserEmail: string = '';
  @ViewChild('patsearchslider', { static: true }) public sidenav: MatSidenav;
  constructor(private schedulerservice: SchedularServiceService
    , private fb: FormBuilder
    , private _taskandgroupservice: TasksAndGroupsService, public dialog: MatDialog
    , private spinner: NgxSpinnerService,
    public dialogRef: MatDialogRef<any>
    , private toastr: ToastrService, private dateservice: SharedService
    , @Inject(MAT_DIALOG_DATA) public data: any
    , private datePipe: DatePipe,) {
    this.getLocationDate();
  }
  @HostListener("document:click", ['$event'])
  documentClickListner(event) {
    if (this.isTo == true) {
      $('#showresut').hide();
    } else {
      $('#showresutcc').hide();
    }
  }
  ngOnInit() {
    $('textarea').keyup(function () {
      var characterCount = $(this).val().length,
        current = $('#current'),
        maximum = $('#maximum'),
        theCount = $('#the-count');

      current.text(characterCount);


      /*This isn't entirely necessary, just playin around*/
      if (characterCount < 70) {
        current.css('color', '#666');
      }
      if (characterCount > 70 && characterCount < 90) {
        current.css('color', '#6d5555');
      }
      if (characterCount > 90 && characterCount < 100) {
        current.css('color', '#793535');
      }
      if (characterCount > 100 && characterCount < 120) {
        current.css('color', '#841c1c');
      }
      if (characterCount > 120 && characterCount < 139) {
        current.css('color', '#8f0001');
      }

      if (characterCount >= 140) {
        maximum.css('color', '#8f0001');
        current.css('color', '#8f0001');
        theCount.css('font-weight', 'bold');
      } else {
        maximum.css('color', '#666');
        theCount.css('font-weight', 'normal');
      }


    });
    this.NewTaskMessagesForm = this.fb.group({
      priority: [''],
      dueDate: [''],
      ToUsersId: [''],
      CCUsersId: [''],
      locationId: [''],
      searchtxt: [''],
      groupNametxt: [''],
      messageTypeId: ['', Validators.required],
      patientName: [''],
      subject: [''],
      txtMessage: [''],
      isEmailNotify: [''],
      userSelected: [''],
      IsToCC: [''],
    });

    // alert(this.data + ' patId :: ' + CommonComponents.patientId)
    // alert(CommonComponents.patientName + ': patient name')
    if (this.data == true) {
      this.searchPatientId = Number(CommonComponents.patientId);
      if (sessionStorage.getItem("patientDob") != "" && sessionStorage.getItem("patientDob") != null && sessionStorage.getItem("patientDob") != undefined) {
        if (CommonComponents.patientName != "" && CommonComponents.patientName != undefined && CommonComponents.patientName != null) {
          this.NewTaskMessagesForm.patchValue({
            patientName: (CommonComponents.patientName + '  ( ' + sessionStorage.getItem("patientDob") + ' )')
            // patientName:CommonComponents.patientName
          })
        }

      }
    } else {
      if (Number(CommonComponents.patientId) != 0) {
        this.searchPatientId = Number(CommonComponents.patientId);
        this.searchPatName = (CommonComponents.patientName + '  ( ' + sessionStorage.getItem("patientDob") + ' )');
        if (sessionStorage.getItem("patientDob") != "" && sessionStorage.getItem("patientDob") != null && sessionStorage.getItem("patientDob") != undefined) {
          if (CommonComponents.patientName != "" && CommonComponents.patientName != undefined && CommonComponents.patientName != null) {
            this.NewTaskMessagesForm.patchValue({
              patientName: (CommonComponents.patientName + '  ( ' + sessionStorage.getItem("patientDob") + ' )')
              // patientName:CommonComponents.patientName
            })
          }

        }
      }
      if (sessionStorage.getItem("patientDob") != "" && sessionStorage.getItem("patientDob") != null && sessionStorage.getItem("patientDob") != undefined) {

        if (CommonComponents.patientName != "" && CommonComponents.patientName != undefined && CommonComponents.patientName != null) {
          this.NewTaskMessagesForm.patchValue({
            patientName: (CommonComponents.patientName + '  ( ' + sessionStorage.getItem("patientDob") + ' )')
          })
        }

      }
    }
    this.NewTaskMessagesForm.patchValue({
      priority: '2',
      locationId: 0
    })
    this.loadAllNewTaskBIndValues();
    this.fromUserName = sessionStorage.getItem("username")
    this.fromCreated = new Date();
    this.NewTaskMessagesForm.patchValue({

    })

  }
  public lstLocations: ILocationDetails[];
  usersList: UserGroupMapping[];
  usersList1: UserGroupMapping[];
  masterUserList: UserGroupMapping[] = [];
  GroupedUserList: TaskGroupUsers[] = [];
  GroupMasterUserList: TaskGroupUsers[] = [];
  public allMessageType: IMasterMessageType[];
  loadAllNewTaskBIndValues() {
    this.spinner.show();
    forkJoin(
      this.schedulerservice.getLocations(),
      this._taskandgroupservice.getAllMappedGroupUsers(0, "AllUsers"),
      this._taskandgroupservice.getTaskGroupedUsers(),
      this._taskandgroupservice.getmessagetype('0')).subscribe(([locationLst, mappedGroupUsers, taskGroupedUser, msgTypes]: any) => {
        this.lstLocations = locationLst;
        this.lstLocations = this.lstLocations.filter(a => a.active == true);
        this.manipultaedata(mappedGroupUsers);
        this.usersList1 = mappedGroupUsers;
        // this.loginUserEmail = this.usersList.filter(x => x.userId == sessionStorage.getItem("loginUserId"))[0].emailId;
        var useremailObj = this.usersList.filter(x => x.userId == sessionStorage.getItem("loginUserId"))
        if (useremailObj.length > 0) {
          this.loginUserEmail = useremailObj[0].emailId
        }
        this.GroupedUserList = taskGroupedUser;
        this.GroupMasterUserList = taskGroupedUser;
        this.allMessageType = msgTypes;
        this.allMessageType = this.allMessageType.filter(x => x.isActive == true)

        this.spinner.hide();
      }
        , (err: any) => {
          this.spinner.hide();
          console.log(err);

        }
      );
  }
  locationDate: string = "";
  getLocationDate() {
    this.dateservice.getservercurrentdate().subscribe(async result => {
      await result;
      this.locationDate = result;

    });

  }

  manipultaedata(data: any) {
    this.masterUserList = data;
    this.usersList = data;
  }

  OnLocationUserFilter(event: any) {
    this.searchfilter(this.NewTaskMessagesForm.controls['searchtxt'].value)
  }
  searchfilterevent(event) {
    let txt = event.target.value.toLowerCase();
    this.searchfilter(txt)
  }
  searchfilter(searchtxt: string) {
    let txt = searchtxt;
    let obj: UserGroupMapping[] = [];
    let selectLocId = this.NewTaskMessagesForm.controls['locationId'].value
    if (selectLocId == '0' || selectLocId == "") {
      obj = this.masterUserList;
    } else {
      obj = this.masterUserList.filter(x => x.userLocations.includes(selectLocId));
    }

    if (txt != '')
      obj = obj.filter(x => x.userName.toLowerCase().includes(txt));

    this.usersList = obj
  }
  searchfilter1(searchtxt: string) {
    let txt = searchtxt;
    let obj: UserGroupMapping[] = [];
    let selectLocId = this.NewTaskMessagesForm.controls['locationId'].value
    if (selectLocId == '0' || selectLocId == "") {
      obj = this.masterUserList;
    } else {
      obj = this.masterUserList.filter(x => x.userLocations.includes(selectLocId));
    }

    if (txt != '') {
      obj = obj.filter(x => x.userName.toLowerCase().includes(txt));
    } else {
      if (this.isTo == true) {
        $('#showresut').hide();
      } else {
        $('#showresutcc').hide();
      }
    }
    this.usersList1 = obj
  }

  GroupNamesearchfilterevent(event) {
    let txt = event.target.value.toLowerCase();
    if (txt != "")
      this.GroupedUserList = this.GroupMasterUserList.filter(x => x.groupName.toLowerCase().includes(txt))
    else
      this.GroupedUserList = this.GroupMasterUserList;
  }

  CCSelectUsers: any = [];
  ToSelectUsers: any = [];
  onUserClick(ele: any) {
    switch (this.isTo) {
      case false:
        if (this.CCSelectUsers.some(x => x.UserID == ele.userId)) {
          //alert("user exist");
          this.toastr.warning('This user already added')
          return
        } else {
          let ccObj: any = {
            UserID: ele.userId,
            UserName: ele.userFullName,
            EmailId: ele.emailId,
            GroupId: "0"
          }
          this.CCSelectUsers.push(ccObj);
        }
        break;
      case true:
        if (this.ToSelectUsers.some(x => x.UserID == ele.userId)) {
          //alert("user exist");
          this.toastr.warning('This user already added')
          return
        } else {
          let toObj: any = {
            UserID: ele.userId,
            UserName: ele.userFullName,
            EmailId: ele.emailId,
            GroupId: "0"
          }
          this.ToSelectUsers.push(toObj);
        }
        break;
      default:
        //alert("select")
        break;
    }
    $('#spanid').text('');

    $('#spanid').focus();
    $('#showresut').hide()

  }
  onUserClickCC(ele: any) {
    switch (this.isTo) {
      case false:
        if (this.CCSelectUsers.some(x => x.UserID == ele.userId)) {
          //alert("user exist");
          this.toastr.warning('This user already added')
          return
        } else {
          let ccObj: any = {
            UserID: ele.userId,
            UserName: ele.userFullName,
            EmailId: ele.emailId,
            GroupId: "0"
          }
          this.CCSelectUsers.push(ccObj);
        }
        break;
      case true:
        if (this.ToSelectUsers.some(x => x.UserID == ele.userId)) {
          //alert("user exist");
          this.toastr.warning('This user already added')
          return
        } else {
          let toObj: any = {
            UserID: ele.userId,
            UserName: ele.userFullName,
            EmailId: ele.emailId,
            GroupId: "0"
          }
          this.ToSelectUsers.push(toObj);
        }
        break;
      default:
        //alert("select")
        break;
    }
    $('#spanidcc').text('');
    $('#spanidcc').focus();
    $('#showresutcc').hide()

  }

  OnGroupNameSelect(ele) {
    switch (this.isTo) {

      case false:
        let ccuserJson = JSON.parse(ele.userJsonData);
        let ccjsonList = ccuserJson.UserData;
        if (this.CCSelectUsers.filter(x => Number(x.GroupId) == ele.groupId).length > 0) {
          this.toastr.warning('This group has been already added')
          return;
        }
        ccjsonList.forEach(element => {
          if (!(this.CCSelectUsers.some(x => x.UserID == element.UserID))) {
            this.CCSelectUsers.push(element);
          }
        });
        // let ccObj1: any = {
        //   UserID: ccjsonList.map(x => x.UserID).toString(),
        //   UserName: ele.groupName,
        //   EmailId: '',
        //   GroupId: ele.groupId
        // }
        // this.CCSelectUsers.push(ccObj1);
        break;
      case true:
        let touserJson = JSON.parse(ele.userJsonData);
        let tojsonList = touserJson.UserData;
        if (this.ToSelectUsers.filter(x => Number(x.GroupId) == ele.groupId).length > 0) {
          this.toastr.warning('This group has been already added')
          return;
        }
        tojsonList.forEach(element => {
          if (!(this.ToSelectUsers.some(x => x.UserID == element.UserID))) {
            this.ToSelectUsers.push(element);
          }
        });
        // let ccObj2: any = {
        //   UserID: tojsonList.map(x => x.UserID).toString(),
        //   UserName: ele.groupName,
        //   EmailId: '',
        //   GroupId: ele.groupId
        // }
        // this.ToSelectUsers.push(ccObj2);
        break;
      default:
        //alert("select")
        break;
    }
  }
  _msgtask: IMessagesTasksInbox;
  IsSingleClickedBtn: boolean = false;
  CreateTask() {

    this.spinner.show()
    this.IsShowUserGroup = true;
    if (this.ToSelectUsers.length == 0) {
      this.toastr.error("Please select TO user");
      this.IsShowUserGroup = false;
      this.spinner.hide()
      return false;
    } else {

      this._msgtask = new IMessagesTasksInbox();
      this._msgtask.FromUserId = encodeURIComponent(sessionStorage.getItem("userId"));
      this._msgtask.CreatedOn = this.locationDate;
      this._msgtask.Priority = this.NewTaskMessagesForm.value.priority;
      this._msgtask.PriorityName = this.NewTaskMessagesForm.value.priority == "1" ? "High" : this.NewTaskMessagesForm.value.priority == "2" ? "Medium" : "Low";
      this._msgtask.DueDate = this.datePipe.transform(this.NewTaskMessagesForm.value.dueDate, "MM/dd/yyyy");
      this._msgtask.MailDueDate = this.datePipe.transform(this.NewTaskMessagesForm.value.dueDate, "MM/dd/yyyy");
      this._msgtask.ToUserIds = this.ToSelectUsers.map(x => encodeURIComponent(x.UserID)).toString();
      this._msgtask.CCUserIds = this.CCSelectUsers.map(x => encodeURIComponent(x.UserID)).toString();
      this._msgtask.TypeId = this.NewTaskMessagesForm.value.messageTypeId;
      let msgList = this.allMessageType.filter(x => x.messagesTypeId == this.NewTaskMessagesForm.value.messageTypeId)
      if (msgList.length > 0) {
        if (msgList[0].messagesType == "General") {
          this._msgtask.Status = 4; // General message type
          this._msgtask.TypeName = msgList[0].messagesType
        } else {
          this._msgtask.Status = 1;
          this._msgtask.TypeName = msgList[0].messagesType
        }
      }
      if (msgList.length == 0) {
        this.toastr.error("Please Message Type");
        this.IsShowUserGroup = false;
        this.spinner.hide()
        return false;
      }
      this.ToSelectUsers.forEach(x => { x.UserID = encodeURIComponent(x.UserID) });
      this.CCSelectUsers.forEach(x => { x.UserID = encodeURIComponent(x.UserID) });

      this._msgtask.PatientId = this.searchPatientId;
      this._msgtask.PatientName = this.searchPatName;
      this._msgtask.Subject = this.NewTaskMessagesForm.value.subject;
      this._msgtask.Note = this.NewTaskMessagesForm.value.txtMessage;
      this._msgtask.IsSendEmailNotification = this.NewTaskMessagesForm.value.isEmailNotify;
      this._msgtask.CreatedBy = encodeURIComponent(sessionStorage.getItem("userId"));
      this._msgtask.LocationId = Number(sessionStorage.getItem("LocationId"));
      this._msgtask.ToUserIdList = this.ToSelectUsers;
      this._msgtask.CCUserIdList = this.CCSelectUsers;
      this._msgtask.FacilityId = Number(sessionStorage.getItem("FacilityId"));
      this._msgtask.TypeOfMessage = 'NewTask';
      this._msgtask.FromUserEmail = this.loginUserEmail;

      //this.spinner.hide()
      this._taskandgroupservice.SaveTasksInfo(this._msgtask).subscribe(data => {
        this.dialogRef.close(true);
        this.toastr.success("Message Sent Successfully")
        this.IsShowUserGroup = false;
        this.spinner.hide()
      },
        (err: any) => {
          this.spinner.hide();
          console.log(err);
          this.IsShowUserGroup = false;
        }
      )
    }

  }

  CloseDailog() {
    this.dialogRef.close(false);
  }
  // ClearTaskValues() {

  // }
  isTo: any = true;
  onFocus(val: boolean) {
    this.isTo = val
  }

  //******Patient Search */
  patientInformation: IPersonalInfo;
  searchPatientId: number = 0;
  searchPatName: string = '';
  onClickPatientSearch() {
    sessionStorage.setItem("ispatSerachPopup", "True");
    const dialogRef = this.dialog.open(PatientSearchComponent, {
      width: '1180px',
      maxWidth:'auto',
       height: 'auto',

      data: { action: true }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result != undefined && result != '') {
        this.patientInformation = result;
        this.searchPatientId = this.patientInformation.patientId;
        this.searchPatName = this.patientInformation.name + '  ( ' + (this.transform(this.patientInformation.dob) + ' )');
        this.NewTaskMessagesForm.patchValue({
          patientName: this.patientInformation.name + '  ( ' + (this.transform(this.patientInformation.dob) + ' )')//patDOB patientId //dPatId
        })
      }
    });
  }
  transform(value: string): string {
    if (value && value != undefined) {
      var datePipe = new DatePipe("en-US");
      value = datePipe.transform(value, 'MM/dd/yyyy');
    }
    return value;
  }
  RemoveUser(userObj: any, type: string, index: number) {
    switch (type) {
      case 'To':
        this.ToSelectUsers.splice(index, 1);
        break;
      case 'CC':
        this.CCSelectUsers.splice(index, 1);
        break;
    }
  }

  validateDate(event: any) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 47) {
      event.preventDefault();
      return false;
    }
    return true;
  }
  funAutoSuggust() {
    var spanid = $('#spanid').text();
    // $('#sel2').find('option[text=spanid]').val()
    if (spanid.toLowerCase().trim() != "")
      $('#showresut').show()
    this.searchfilter1(spanid.toLowerCase().trim());
  }
  funAutoSuggustCC() {
    var spanidcc = $('#spanidcc').text();
    // $('#sel2').find('option[text=spanid]').val()
    if (spanidcc.toLowerCase().trim() != "")
      $('#showresutcc').show();
    this.searchfilter1(spanidcc.toLowerCase().trim());
  }

  isTofocus() {
    $('#spanid').focus();
    this.isTo = true;
    $('#showresutcc').hide()
  }

  isCCFocus() {
    $('#spanidcc').focus();
    this.isTo = false;
    $('#showresut').hide();
  }
  checkEmail: boolean = false;
  checkEmailNotification(event) {
    if (event.target.checked == true) {
      this.checkEmail = true;
    } else {
      this.checkEmail = false;
    }
  }
}
